<!-- ------------------------Modal Section Start-------------------------------- -->
<div class="nav_Consult">
    <a mat-button (click)="openDialog()"> {{ButtonName}} </a>
</div>